/* tslint:disable */
/* eslint-disable */
/**
 * Survey
 * 現地調査用API
 *
 * The version of the OpenAPI document: 1.0
 * Contact: kiuchi@wcdi.co.jp
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { GetCostcoProducts200ResponseAllOfData } from './GetCostcoProducts200ResponseAllOfData';
import {
    GetCostcoProducts200ResponseAllOfDataFromJSON,
    GetCostcoProducts200ResponseAllOfDataFromJSONTyped,
    GetCostcoProducts200ResponseAllOfDataToJSON,
} from './GetCostcoProducts200ResponseAllOfData';

/**
 * 
 * @export
 * @interface SearchCostcoProducts200Response
 */
export interface SearchCostcoProducts200Response {
    /**
     * 
     * @type {GetCostcoProducts200ResponseAllOfData}
     * @memberof SearchCostcoProducts200Response
     */
    data: GetCostcoProducts200ResponseAllOfData;
    /**
     * 
     * @type {object}
     * @memberof SearchCostcoProducts200Response
     */
    meta: object;
}

/**
 * Check if a given object implements the SearchCostcoProducts200Response interface.
 */
export function instanceOfSearchCostcoProducts200Response(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "data" in value;
    isInstance = isInstance && "meta" in value;

    return isInstance;
}

export function SearchCostcoProducts200ResponseFromJSON(json: any): SearchCostcoProducts200Response {
    return SearchCostcoProducts200ResponseFromJSONTyped(json, false);
}

export function SearchCostcoProducts200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): SearchCostcoProducts200Response {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': GetCostcoProducts200ResponseAllOfDataFromJSON(json['data']),
        'meta': json['meta'],
    };
}

export function SearchCostcoProducts200ResponseToJSON(value?: SearchCostcoProducts200Response | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': GetCostcoProducts200ResponseAllOfDataToJSON(value.data),
        'meta': value.meta,
    };
}

